import {Editor} from "../editors/Editor.js";
import {Temp} from "../utils/Temp.js";
import {TextEditor} from "../editors/TextEditor.js";
import {TextAreaEditor} from "../editors/TextAreaEditor.js";
import {getElementParams} from "./ProcessElement.js";
import {SelectEditor} from "../editors/SelectEditor.js";

/**
 * @typedef {object} SwitchType
 * @property {string} class - java class of the node
 * @property {string} name - human readable name
 * @property {function} editorConstructor
 */

export class ProcessElementProps extends Editor {
	/**
	 * @param {ProcessEditor} processEditor
	 * @param fieldPath
	 * @param obj
	 * @param member
	 */
	constructor(processEditor, fieldPath, obj, member) {
		super(null, fieldPath, obj, member);
		this.processEditor = processEditor;
	}


	/**
	 * @return {SwitchType[]}
	 */
	getTypeEditors() {
		return [];
	}


	rebuild() {
		this.root = Temp.tag('div', { clazz: 'props-basic'});

		let d = this.data;

		this.types = this.getTypeEditors();
		if (this.types.length > 1) {
			this.typeEditor = new SelectEditor(this, this.field+".class", d, "class", { items: this.itemsFromSwitchTypes() });
			this.root.append(this.typeEditor.ui);
		}
		this.nameEditor = new TextEditor(this, this.field + ".name", d, "name", { clazz:"width100p" });
		this.descEditor = new TextAreaEditor(this, this.field + ".description", d, "description", {});
		this.root.append(this.nameEditor.ui);
		this.root.append(this.descEditor.ui);

		const pars = getElementParams(d["class"]);

		if (pars) {
			// Defaults
			if (pars.data) {
				for (let paramWithDefault in pars.data) {
					if (pars.data.hasOwnProperty(paramWithDefault)) {
						if (!d.hasOwnProperty(paramWithDefault)) d[paramWithDefault] = pars.data[paramWithDefault];
					}
				}
			}
			//this.propsEditor = new FormEditor(null, this.field + ".props", this.obj, this.member, [], pars.form);
			this.root.append(this.propsEditor.ui);
		}
	}

	itemsFromSwitchTypes() {
		const items = [];
		for (let i = 0; i < this.types.length; i++) {
			const t = this.types[i];
			items.push({ name:t.name, value: t.class});
		}
		return items;
	}


	onChange(field, newValue) {
		this.processEditor.update();
		return true;
	}
}